import { OnlineFixedPageEnum, OnlineFixedTemplateEnum, PRESET_CUSTOM_PAGE_IDS } from '../config'

export enum PageType {
  UserAddedCustomPage = 'user_added_custom',
  PresetCustomPage = 'preset_custom',
  PredefinedFixedPage = 'predefined_fixed',
}

export interface IPageConfig {
  type: PageType
  pageId: string
}

export interface UserAddedCustomPageConfig extends IPageConfig {
  type: PageType.UserAddedCustomPage
  pageId: string
  design: any
}

export type PresetCustomPageIds = typeof PRESET_CUSTOM_PAGE_IDS[number]

export interface PresetCustomPageConfig extends IPageConfig {
  type: PageType.PresetCustomPage
  pageId: PresetCustomPageIds
  design: any
}

export interface PredefinedFixedPageConfig extends IPageConfig {
  type: PageType.PredefinedFixedPage
  pageId: OnlineFixedPageEnum | OnlineFixedTemplateEnum
}

export type PagesConfig = UserAddedCustomPageConfig | PresetCustomPageConfig | PredefinedFixedPageConfig
